import type { SalonProfile } from "@/features/salon";

/** One figure in the hero's row: the number, set large, and what it counts. */
export interface HomeStat {
  value: string;
  label: string;
  /** Whether a star follows the value, in the accent: the rating. */
  star?: boolean;
}

/** What the salon wrote for its about band (FR-SA-191): its own numbers replace the real ones as a set. */
export interface HomeStatsCustom {
  stats: readonly { value: string; label: string }[];
}

/**
 * The salon in numbers (FR-SA-190), for the hero's figure row (design note
 * salon-booking-organic-wellness.md section 6 item 2): "4.6★ from 128 visits", then the stylists and the
 * services. Every figure is real; a number that is zero or unknown is left out rather than shown as 0.
 * A salon that wrote its own numbers gets those instead.
 */
export function homeStats(
  salon: SalonProfile,
  stylists: number,
  services: number,
  custom?: HomeStatsCustom | null,
): HomeStat[] {
  if (custom && custom.stats.length > 0) return custom.stats.map((stat) => ({ ...stat }));
  const stats: HomeStat[] = [];
  if (salon.rating) {
    stats.push({
      value: salon.rating.average.toFixed(1),
      star: true,
      label: `from ${salon.rating.count.toLocaleString("en-IN")} visits`,
    });
  }
  if (stylists > 0) stats.push({ value: String(stylists), label: stylists === 1 ? "Stylist taking bookings" : "Stylists taking bookings" });
  if (services > 0) stats.push({ value: String(services), label: services === 1 ? "Service on the menu" : "Services on the menu" });
  return stats;
}
